import { render, staticRenderFns } from "./EditSite.vue?vue&type=template&id=fb4c53e2&scoped=true&"
import script from "./EditSite.vue?vue&type=script&lang=js&"
export * from "./EditSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4c53e2",
  null
  
)

export default component.exports